import { AfterViewInit, ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { DragScrollComponent } from '@le2xx/ngx-drag-scroll';
import { ReviewListItem } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-reviews-carousel',
  templateUrl: './reviews-carousel.component.html',
  styleUrls: ['./reviews-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReviewsCarouselComponent implements AfterViewInit {
  @Input() meetingReviews: ReviewListItem[];
  @ViewChild('dragScroll', { read: DragScrollComponent }) ds: DragScrollComponent;
  private width = 584;

  constructor(public deviceService: DeviceDetectorService) {}

  ngAfterViewInit() {
    if (this.deviceService.isDesktop()) {
      this.width = 584;
    }
    if (this.deviceService.isMobile()) {
      this.width = 345;
    }
  }

  onMoveLeft() {
    this.ds.moveLeft();
  }

  onMoveRight() {
    this.ds.moveRight();
  }

  public trackByFn(index) {
    return index;
  }
}
